import { Component } from '@theme/component';
import { CartUpdateEvent } from '@theme/events';

/**
 * Wraps the Rebuy widget embedded in the cart drawer.
 */
class FhCartRecommendations extends Component {
  connectedCallback() {
    super.connectedCallback();

    // Rebuy only scans the page when it loads, so a widget added later (the drawer re-rendering after the
    // cart goes from empty to filled) has to be initialised by hand. Before Rebuy loads, its own scan finds it.
    if (!this.querySelector('[data-rebuy-id]:not([data-initialized])')) return;

    window.Rebuy?.init?.();
  }
}

if (!customElements.get('fh-cart-recommendations')) {
  customElements.define('fh-cart-recommendations', FhCartRecommendations);
}

/** @type {AbortController | null} */
let cartFetch = null;

/**
 * Rebuy adds to the cart with its own request, which the theme never hears about. Announce the change so the
 * cart drawer re-renders and the cart bubble count updates.
 */
async function handleRebuyAdd() {
  cartFetch?.abort();
  const abortController = new AbortController();
  cartFetch = abortController;

  try {
    const response = await fetch(new URL(`${Theme.routes.cart_url}.js`, window.location.origin), {
      signal: abortController.signal,
    });
    const cart = await response.json();

    document.dispatchEvent(
      new CartUpdateEvent(cart, 'fh-cart-recommendations', {
        source: 'fh-cart-recommendations',
        itemCount: cart.item_count,
      })
    );
  } catch (error) {
    if (abortController.signal.aborted) return;
    console.error(error);
  } finally {
    if (cartFetch === abortController) cartFetch = null;
  }
}

// Fired by Rebuy after any of its widgets has added a product to the cart
document.addEventListener('rebuy.add', handleRebuyAdd);
